import React from "react";

import { Link, Text } from "/component/base";
import { layout } from "/styles";

import { Base, Links } from "./CtaCard.styles";
import { Props } from "./CtaCard.types";

const CtaCard = ({ className, links, title, subtitle }: Props) => {
  return (
    <Base aria-hidden className={className}>
      <Text variant="title3" element="div">
        {title}
      </Text>

      <Text
        color="textSecondary"
        css={layout.margin("condensed", "skip", "skip", "skip")}
        element="div"
      >
        {subtitle}
      </Text>

      {links && links.length > 0 && (
        <Links css={layout.margin("standard", "skip", "skip", "skip")}>
          {links?.map((link) => {
            if (link.to) {
              return (
                <li key={link.title}>
                  <Link.Button to={link.to} variant={link?.variant || "primary"}>
                    {link.icon}
                    {link.title}
                  </Link.Button>
                </li>
              );
            } else if (link.href) {
              return (
                <li key={link.title}>
                  <Link.Button
                    as="a"
                    to=""
                    href={link.href}
                    variant={link?.variant || "primary"}
                    // NOTE: Using `css` here causes the links to lose styles
                    style={{ width: "100%" }}
                  >
                    {link.icon}
                    {link.title}
                  </Link.Button>
                </li>
              );
            }

            return null;
          })}
        </Links>
      )}
    </Base>
  );
};

export default CtaCard;
